import React, { createContext } from 'react';
import useChangeTheme from '../hooks/useChangeTheme';

export const ThemeContext = createContext();

export default function ThemeProvider(props) {

    const [isLight, setIsLight] = useChangeTheme();

    return(
        <ThemeContext.Provider value={[isLight, setIsLight]}>
            {props.children}
        </ThemeContext.Provider>
    )
}